import {
  Condition,
  MetafieldMatchType,
} from "@redotech/redo-model/return-flow/condition";
import {
  productMetafieldFromModel,
  validateProductMetafieldCondition,
  type ProductMetafieldState,
} from "@redotech/redo-model/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const PRODUCT_METAFIELD = (
  Details: React.ComponentType<
    ConditionTypeDetailsProps<ProductMetafieldState>
  >,
): ConditionType<ProductMetafieldState, Condition.ProductMetafield> => ({
  name: "Product metafield",
  description(state) {
    return `Metafield: ${state.namespace}.${state.key}`;
  },
  Details(props: ConditionTypeDetailsProps<ProductMetafieldState>) {
    return React.createElement(Details, props);
  },
  empty: {
    namespace: "",
    key: "",
    comparison: MetafieldMatchType.EXACT,
    value: "",
  },
  fromModel(model: Condition.ProductMetafield) {
    return productMetafieldFromModel(model);
  },
  toModel(state) {
    return { type: Condition.PRODUCT_METAFIELD, ...state };
  },
  valid(state) {
    return validateProductMetafieldCondition(state).valid;
  },
});

export { type ProductMetafieldState } from "@redotech/redo-model/return-flow/condition-validate";
